import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import {Store} from "../../../services/store.service";
import {LogicCondition} from "../../../models/jsonlogic/logic-condition";
import {QueryBuilder} from "./query-builder";

@Component({
  selector: "determinant-query-readonly",
  templateUrl: "./determinant-query-readonly.html",
  styleUrls: ["./query-builder.scss"],
})
export class DeterminantQueryReadOnly implements OnChanges {

  @Input() public jsonDeterminants: string;
  @Input() public determinantMapById: { [key: string]: string };
  @Input() public hasError: boolean = false;
  public determinantItems: any[] = [];

  constructor(public store: Store) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.jsonDeterminants && changes.jsonDeterminants.currentValue && changes.jsonDeterminants.currentValue.length > 0) {
      const conditions = JSON.parse(changes.jsonDeterminants.currentValue);
      conditions.forEach((it, index, itemsArray) => {
        this.determinantItems[index] = {type: conditions[index].type, conditions: conditions[index].items}; });
    } else {
      this.determinantItems = [];
    }
  }

  public findDeterminantName(item: LogicCondition): string {
    return QueryBuilder.findDeterminantName(item, this.determinantMapById);
  }

}
